// extracted by mini-css-extract-plugin
export var falconContainer = "_v4-2";
export var offerCenter = "_v4-0";
export var roktContainer = "_v4-1";